var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"top":"","right":"","timeout":_vm.timeout,"color":_vm.color},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('v-btn',{attrs:{"dark":"","text":""},on:{"click":function($event){_vm.snackbar = false}}},[_vm._v(" Close ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }